import { SET_CONTACT_DETAILS } from "./ShopType";


export const setContactDetailsRedux = (data) => {
  return {
    type: SET_CONTACT_DETAILS,
    payload: data,
  };
};
